import { render } from "./MatchingMedia.vue?vue&type=template&id=4c3af9ba&scoped=true&mode=ios"
import script from "./MatchingMedia.vue?vue&type=script&lang=js"
export * from "./MatchingMedia.vue?vue&type=script&lang=js"

import "./MatchingMedia.vue?vue&type=style&index=0&id=4c3af9ba&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3af9ba"]])

export default __exports__